import { noLog } from 'app/shared/util/methode-util';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import AppComponent from './app';
import { clearAuthentication } from './modules/user/service/userService';
import setupAxiosInterceptors from './shared/config/axios-interceptor';
import DevTools from './shared/config/devtools';
import initStore, { routerHistory } from './shared/config/store';
import { registerLocale } from './shared/config/translation';

const devTools = process.env.NODE_ENV === 'development' ? <DevTools /> : null;
process.env.NODE_ENV === 'production' && noLog();

const store = initStore();
registerLocale(store);

const actions = bindActionCreators({ clearAuthentication }, store.dispatch);
setupAxiosInterceptors(() => actions.clearAuthentication('login.error.unauthorized'));

const rootEl = document.getElementById('root');

const render = Component =>
  // eslint-disable-next-line react/no-render-return-value
  ReactDOM.render(
    <Provider store={store}>
      <Router history={routerHistory}>
        <Component />
      </Router>
    </Provider>,
    rootEl
  );

render(AppComponent);
